<template>
  <div id="Modal" :class="type">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            
        
          <div class="close" @click="$emit('close');$emit('forceClose')">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
          </div>

            <div class="modal-header">
              <slot name="header"> default header </slot>
            </div>
            <div class="modal-body">
              <slot name="body"> default body </slot>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="$emit('close')">
                  <slot name="button"></slot>
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
    props:['type'],
    mounted(){        
        this.$store.commit('showModal', true);
        document.body.classList.add('overflowHidden');
    },
    unmounted(){
        this.$store.commit('showModal', false);
        document.body.classList.remove('overflowHidden');
    }
}
</script>


<style lang="scss">
.modal-mask {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #323232;
    transition: opacity 0.3s ease;

    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  position: relative;
    width: 380px;
    margin: 0px auto;
    padding: 20px 40px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgb(0 0 0 / 33%);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    text-align: center;
}
.modal-body {
  margin: 20px 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>